export default "__VITE_ASSET__CGQjf2m0__"